import { ConfiguratorGroupDto, ConfiguratorOptionDto } from '@/services/configurator';

/**
 * Decides which options the buyer sees for a group.
 *
 *   group locked for buyer? (signed or deadline expired, NOT a style-forced lock)
 *     |
 *     +-- no  --> show ALL options (buyer can still change selection)
 *     |
 *     +-- yes --> has a selected option?
 *                   |
 *                   +-- yes --> show ONLY the selection (read-only)
 *                   |
 *                   +-- no  --> show ALL options (read-only, nothing was picked)
 *
 * Mirrors the legacy buyer options dialog: once locked, the unchosen products
 * drop away so the buyer just sees what they ended up with.
 *
 * In the showroom there is no buyer and no signing, and `isLocked` there only
 * reflects an expired deadline (irrelevant in the showroom) — so options are
 * never collapsed to the selection. Without this, picking a style would hide the
 * alternatives the visitor must still be able to switch between. Mirrors
 * isGroupSigned's showroom handling.
 */
export function getVisibleBuyerOptions(group: ConfiguratorGroupDto, isShowroom = false): ConfiguratorOptionDto[] {
    const lockedForBuyer = !isShowroom && group.isLocked && !group.lockedByForceSelectionPreset;
    if (!lockedForBuyer) {
        return group.options;
    }

    const selected = group.options.filter((option) => option.selected);
    return selected.length > 0 ? selected : group.options;
}
